// extracted by mini-css-extract-plugin
export var circle = "_49-2";
export var icon = "_49-a";
export var iconHighlight = "_49-0";
export var lg = "_49-8";
export var md = "_49-7";
export var outline = "_49-4";
export var sm = "_49-6";
export var square = "_49-1";
export var xl = "_49-9";
export var xs = "_49-5";
export var xxs = "_49-3";